import { render } from "./CookieSettingsDialog.vue?vue&type=template&id=cf17d310&scoped=true"
import script from "./CookieSettingsDialog.vue?vue&type=script&lang=js"
export * from "./CookieSettingsDialog.vue?vue&type=script&lang=js"

import "./CookieSettingsDialog.vue?vue&type=style&index=0&id=cf17d310&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf17d310"]])

export default __exports__